/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GeoCoordinatesForRegion {
    getFixupPrototypeFunction() { return GeoCoordinatesForRegion.fixupPrototype; }

    static newInstance(model: Partial<GeoCoordinatesForRegion>): GeoCoordinatesForRegion {
        let obj = Object.assign(new GeoCoordinatesForRegion(), model);
        GeoCoordinatesForRegion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GeoCoordinatesForRegion>): GeoCoordinatesForRegion {
        if (!model) return null;
        return GeoCoordinatesForRegion.newInstance(<GeoCoordinatesForRegion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GeoCoordinatesForRegion) {
        if (!obj) return;

        models.GeoCoordinatesForRegion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GeoCoordinatesForRegion): boolean {
        Object.setPrototypeOf(obj, GeoCoordinatesForRegion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.latitude === undefined) {
            this.latitude = 0;
        }
        if (this.longitude === undefined) {
            this.longitude = 0;
        }
    }

    latitude: number;

    longitude: number;

    iso_a3_code: string;

    region: string;

    normalized_region: string;

}
